import axios from 'axios';
import {clearAlerts, setAlert} from './alert';
import {
    CLEAR_ERRORS,
    GET_EMPLOYEE_TRANSACTIONS,
    GET_EMPLOYEES_TRANSACTIONS,
    SET_LOADING,
    UNSET_LOADING
} from './types';
import {request} from "../utils/service";

export const setLoading = () => (dispatch) => {
    dispatch({
        type: SET_LOADING,
    });
};
export const unsetLoading = () => (dispatch) => {
    dispatch({
        type: UNSET_LOADING,
    });
};

export const updateTransaction = (employee_id = null, transaction, filters = {}) => async (dispatch) => {

    dispatch(clearAlerts());
    dispatch(setLoading());
    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };


    let res = {}
    try {

        res = await axios.post(`/employee/${employee_id}/transactions`, transaction, config);
        // if (employee_id){
        // }else{
        //     res = await axios.post(`/employee-transactions/`, JSON.stringify(transaction), config);
        // }

        dispatch(setAlert("Transaksiya tahrirlandi!", 'success'));
        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message, 'danger'));
        dispatch(unsetLoading());
        return false;
    }
};

export const getEmployeesTransactions = (page = 1, filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '';
    if (filters) {
        Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
    }
    const res = await request(`/employee-transactions?page=${page}${queryParams}`, {method: 'GET'}, dispatch);


    if (res.hasOwnProperty('errors')) {
        const err = res.errors;
        if (err.response?.status === 403) {
            // 403 error already handled in service.js, just stop loading
            dispatch(unsetLoading());
            return;
        }
        dispatch(setAlert(err.response.statusText, 'danger'));
    } else {
        dispatch({
            type: GET_EMPLOYEES_TRANSACTIONS,
            payload: res
        });
        if (res.clients?.data?.length === 0) {
            dispatch(setAlert("Qidiruv bo'yicha hech narsa topilmadi!", 'warning'));
        }
    }
};

// getRowData after update in table
export const getEmployeeTransactions = (employee_id, filters = {}) => async (dispatch) => {
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '?';
    if (filters) {
        Object.keys(filters).map((key, index) => index === 0 ? queryParams += `${key}=${filters[key]}` : queryParams += `&${key}=${filters[key]}`);
    }
    const res = await request(`/single-employee-transactions/${employee_id}${queryParams}`, {method: 'GET'}, dispatch);


    if (res.hasOwnProperty('errors')) {
        const err = res.errors;
        if (err.response?.status === 403) {
            // 403 error already handled in service.js, just stop loading
            dispatch(unsetLoading());
            return;
        }
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
        return res;
    } else {
        dispatch({
            type: GET_EMPLOYEE_TRANSACTIONS,
            payload: res
        });
    }
};

// download report
export const downloadEmployeeReport = (filters = {}) => async (dispatch) => {
    filters.object = 'employee';
    dispatch(setLoading());
    dispatch(clearAlerts());
    let queryParams = '?';
    if (filters) {
        Object.keys(filters).map((key, index) => index === 0 ? queryParams += `${key}=${filters[key]}` : queryParams += `&${key}=${filters[key]}`);
    }
    const res = await request(`/reports/${queryParams}`, {method: 'GET'}, dispatch);
    if (res?.hasOwnProperty('errors')) {
        const err = res.errors;
        dispatch(setAlert(err.response.statusText, 'danger'));
        dispatch(unsetLoading());
        return false;
    } else {
        dispatch(unsetLoading());
        return res?.link;
    }
};


export const clearErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    });
};







